import Instance from "../../../../Axios";

// New Actions for the app

const GetCredPedidosAdicionaisDocs = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/pedidosAdicionaisDocs`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_PEDIDOS_ADICIONAIS_DOCS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredPedidosAdicionaisDocs;
